export default function GetSignatures(composeType, isInternal, token) {
	return fetch("https://#{CustomDomain}#/api/GetSignatures/" + composeType + "/" + isInternal, {
		headers: {
			"osc-authorization": `Bearer ${token}`,
		},
	}).then((x) => x.json());
}
